<template>
	<div class="datacenter">
		<div class="centerhead">
				<div class="centerleft">
						<img 
			class="back-img"
			src="@/assets/images/back.png"
			alt="后退"
			@click="onBack(backPara)" />
				</div>
				<div class="centermiddle">
						<div class="search-input-wrap" v-show="isSearch">
								<form class="search-input-wrap--inner" action="#">
									<input ref="searchIpt"
										class="search-input"
										v-model="searchString"
										:placeholder="searchPh"
										type="search"
										@change="getChange"
									/>
									<!-- 
										@keypress="onSearchPress" -->
								</form>
								<span v-show="searchString"
										class="cancel-btn"
										@click="onSearchClearClick">×</span>
								<div @click="onSearchPress" class="databtn">搜索</div>
						</div>
				</div>
		</div>
		<div class="datatitle" v-show="isCenter">
			<img class="titleicon" src="@/assets/images/data/datacenter.jpg" alt="">
			<span class="titlename">友绿数据中心</span>
		</div>
		<div class="datacontent" v-show="isCenter">
			<div class="dataitem" v-for="(cneterItem, index) in dataCenters" :key="index" @click="selectData(cneterItem)">
				<div class="itemiconlayout">
					<img class="itemicon" :src="cneterItem.imgPath" alt="">
				</div>
				<span class="itemname">{{cneterItem.name}}</span>
			</div>
		</div>
		<div v-show="!isCenter">
			<!-- 检索出来的内容 -->
			<div class="datatitle">
				<img class="titleicon" src="@/assets/images/data/datacenter.jpg" alt="">
				<span class="titlename">{{selectName}}</span>
			</div>
			<!-- 排序布局 -->
			<div class="sorts">
				<div class="sortitem" v-for="(sortItems, index) in sortArr" :key="index" @click="showPicker=true">
					<span>{{sortItems.name}}</span>
					<img class="sortimg" :src="sortItems.imagePath" alt="">
				</div>
			</div>
			<!-- 检索出来的列表 -->
			<van-pull-refresh
				v-if="filterSortList.length>0"
				v-model="isRefreshing"
				@refresh="onRefresh"
				v-infinite-scroll="loadMore"
				:infinite-scroll-disabled="bottomLoading">
				<div class="sortlist" v-for="(listItem, index) in filterSortList" :key="index">
					<div class="listleft">
						<div class="listimg">
							<img :src="listItem.img_path" alt="">
						</div>
						<div class="listimg">
							<div class="listdetial" @click="dataDetial(listItem.jump_id)">详细</div>
						</div>
					</div>
					<div class="listright">
						<div class="listtitle">{{listItem.name}}</div>
						<div class="listcontent" v-for="(dItem,index) in listItem.other" :key="index">{{dItem.title}}：{{dItem.value}}</div>
						<!-- <div class="listcontent">国内认证面积：{{listItem.gmeter}}</div>
						<div class="listcontent">国际认证面积：{{listItem.imeter}}</div>
						<div class="listcontent">评估年份：{{listItem.year}}</div> -->
					</div>
				</div>
			</van-pull-refresh>
			<div v-else class="no-content">
				暂无数据
			</div>
		</div>	
		<van-popup class="popwindow" v-model="popShow" round position="right" :style="{ height: '100%', width: '60%' }" >
			<div class="poptitle">数据筛选</div>
			<div class="datatitle">
				<img class="titleicon" src="@/assets/images/data/datacenter.jpg" alt="">
				<span class="titlename">数据分类</span>
			</div>
			<div class="greendev">
				<select class="devselect">
					<option v-for="(item, index) in devOption" :key="index" v-model="greenDevVal" :options="devOption">
						{{item.name}}
					</option>
				</select>
			</div>
			<!-- 评估年份 -->
			<div class="datayear">
				评估年份：
			</div>
			<div class="greendev databottom">
				<select class="devselect">
					<option v-for="(item, index) in dataYear" :key="index" v-model="dataYear[0]" :options="devOption">
						{{item}}
					</option>
				</select>
			</div>
			<!-- 国内认证面积 -->
			<templete v-show="selectType=='101'">
				<div class="datayear">
					国内认证面积：
				</div>
				<div class="greendev databottom">
					<select class="devselect">
						<option v-for="(item, index) in dataMeter" :key="index" v-model="greenDevVal" :options="devOption">
							{{item.name}}
						</option>
					</select>
				</div>
			</templete>
			<templete v-show="selectType=='102'">
				<!-- 商场平均坪效： -->
				<div class="datayear">
					商场平均坪效：
				</div>
				<div class="greendev databottom">
					<select class="devselect">
						<option v-for="(item, index) in dataMeter" :key="index" v-model="greenDevVal" :options="devOption">
							{{item.name}}
						</option>
					</select>
				</div>
			</templete>
			<!--国际认证面积 -->
			<templete v-show="selectType=='101' || selectType=='102'">
				<div class="datayear">
					国际认证面积：
				</div>
				<div class="greendev databottom">
					<select class="devselect">
						<option v-for="(item, index) in dataMeter" :key="index" v-model="greenDevVal" :options="devOption">
							{{item.name}}
						</option>
					</select>
				</div>
			</templete>
			<!--PRIMB得分 -->
			<templete v-show="selectType=='101'">
				<div class="datayear">
					PRIMB得分：
				</div>
				<div class="greendev databottom">
					<select class="devselect">
						<option v-for="(item, index) in devOption" :key="index" v-model="greenDevVal" :options="devOption">
							{{item.name}}
						</option>
					</select>
				</div>
			</templete>
			<templete v-show="selectType=='102'">
				<!--M2E得分 -->
				<div class="datayear">
					M2E得分：
				</div>
				<div class="greendev databottom">
					<select class="devselect">
						<option v-for="(item, index) in devOption" :key="index" v-model="greenDevVal" :options="devOption">
							{{item.name}}
						</option>
					</select>
				</div>
			</templete>
			<!--认证体系 -->
			<templete v-show="selectType=='103' || selectType=='104'">
				<div class="datayear">
					认证体系：
				</div>
				<div class="greendev databottom">
					<select class="devselect">
						<option v-for="(item, index) in origineSys" :key="index" v-model="greenDevVal" :options="devOption">
							{{item.name}}
						</option>
					</select>
				</div>
				<!--地区： -->
				<div class="datayear">
					地区：
				</div>
				<div class="greendev databottom">
					<select class="devselect">
						<option v-for="(item, index) in areaArr" :key="index" v-model="greenDevVal" :options="devOption">
							{{item.name}}
						</option>
					</select>
				</div>
			</templete>
		</van-popup>
		<van-popup v-model="showPicker" position="bottom">
		<van-picker
			show-toolbar
			:columns="dataYear"
			@confirm="filterList"
			@cancel="showPicker = false"
		/>
</van-popup>
	</div>
</template>
<script>
import { Swipe, SwipeItem, Button, Popup, DropdownMenu, DropdownItem, Picker } from 'vant';
// import { Dropdown, DropdownMenu, DropdownItem }  from 'element-ui';
import envnetBus from '@/utils/eBus'
import DigitalItem from '../../components/DigitalItem';
import BannerItem from '../../components/BannerItem';
import TopBar from '@/components/TopBar'
import LineEcharts from '@/components/LineEcharts'
import CardItem from '@/components/CardItem'
import ColumEcharts from '@/components/ColumEcharts'
import Ranking from '@/components/Ranking'
import TabItem from '@/components/TabItem'
import PieEcharts from '@/components/PieEcharts'
import DataBaseBtn from '@/components/DataBaseBtn'
import apiUtil from '@/utils/apiUtil'
import apiConst from '@/consts/apiConst'
export default {
	name: 'indexSwiperView',
	props: ['keepCenter']
	,
	components: {
		'van-swipe': Swipe,
		'van-swipe-item': SwipeItem,
		DigitalItem,
		BannerItem,
		TopBar,
		LineEcharts,
		CardItem,
		ColumEcharts,
		Ranking,
		TabItem,
		PieEcharts,
		DataBaseBtn,
		'van-button': Button,
		'van-popup': Popup,
		// 'el-dropdown': Dropdown,
		// 'el-dropdown-menu': DropdownMenu,
		// 'el-dropdown-item': DropdownItem,
		'van-dropdown-menu': DropdownMenu,
		'van-dropdown-item': DropdownItem,
		'van-picker': Picker
	},
	data(){
		return{
			isRefreshing: false,
			bottomLoading: false, // 是否正在触底加载
			// 组件取消border
			hasBorder:true,
			// 首页排行布局隐藏顶部及底部更多布局
			isHidden:true,
			searchPh: '公司名称/项目名称/认证体系',
			// onSearchPress: '',
			searchString: '',
			popShow: false,
			dataCenters: [
				{ imgPath: require('@/assets/images/data/center01.jpg'), name: '中国房地产企业绿色开发指数', id: '101' },
				{ imgPath: require('@/assets/images/data/center02.jpg'), name: ' 中国商业地产企业绿色运营指数', id: '102' },
				{ imgPath: require('@/assets/images/data/center03.jpg'), name: '中国绿色建筑认证体系市场数据库', id: '103' },
				{ imgPath: require('@/assets/images/data/center04.jpg'), name: '中国健康建筑认证体系市场数据库', id: '104' },
			],
			isRound: true,
			devOption: [
				{ name: '中国房地产企业绿色开发指数', value: 0 },
				{ name: '中国商业地产企业绿色运营指数', value: 1 },
				{ name: '中国绿色建筑认证体系市场数据库', value: 2 },
				{ name: '中国健康建筑认证体系市场数据库', value: 3 },
			],
			dataYear: [
			],
			showPicker: false,
			dataMeter: [
				{ name: '10-50万平方米', value: 0 },
				{ name: '50-100万平方米', value: 1 },
				{ name: '100-150万平方米', value: 2 },
				{ name: '200万平方米以上', value: 3 },
			],
			greenDevVal: '',
			// 显示数据中心还是筛选后的值
			isCenter: true,
			sortArr: [
				// { name: '综合', imagePath: require('@/assets/images/data/sort.png'), value: '0'},
				// { name: '得分', imagePath: require('@/assets/images/data/sort.png'), value: '1'},
				{ name: '年份', imagePath: require('@/assets/images/data/sort.png'), value: '2'}
				// { name: '国内认证面积', imagePath: require('@/assets/images/data/sort.png'), value: '3'},
				// { name: '国际认证面积', imagePath: require('@/assets/images/data/sort.png'), value: '4'},
			],
			sortList: [],
			filterSortList: [],
			isSearch: false,
			backPara: 'center',
			selectName: '',
			origineSys: [
				{ id: '0', name: '中国绿标一星'},
				{ id: '1', name: '中国绿标二星'},
				{ id: '2', name: '中国绿标三星'}
			],
			areaArr: [
				{ id: '0', name: '全国'},
				{ id: '1', name: '华北'},
				{ id: '2', name: '东北'}
			],
			selectType: '1',
			showSelect: false,
			page: 1,
			filterid: '',
			filterArr: [],
			isFinish: false,
			datalength: 10
		}
	},
	watch:{
	},
	props: ['isMain', 'newsItemList', 'digitalList', 'custom', 'cate_id', 'isNoContent','bannerType', 'typeId'],
	mounted(){
		envnetBus.$on('loginDataBase',target => {
			this.isCenter = true;
		})
		this.filterArr = this.dataCenters.filter(item => {
			return item.id === this.typeId
		})
		if (this.typeId) {
			this.selectData(this.filterArr[0])
		}
	},
	methods:{
		// 加载更多
		loadMore() {
			if (this.datalength == 10) {
				this.page += 1;
				this.getSearch(this.selectType)
			}
		},
		// 刷新
		onRefresh() {
			this.isRefreshing = false
		},
		// 根据年筛选list
		async filterList(value) {
			const res = await apiUtil.get(apiConst.dataSearch+'?id='+this.filterid + '&year=' + value);
			this.sortList = res.data;
			this.filterSortList = res.data;
			this.showPicker = false
		},
		async getSearch(id){
			console.log(this.page)
			this.filterid = id
			let params = ''
			if (this.searchString != '') {
				params = { id: this.selectType, page: this.page, keywords: this.searchString }
			} else {
				params = {id: id, page: this.page}
			}
			const res = await apiUtil.get(apiConst.dataSearch, params);
			this.datalength = res.data.length
			this.sortList = res.data;
			this.filterSortList = this.filterSortList.concat(res.data);
			this.dataYear = res.year
		},
		dataDetial(id){
			console.log(id)
			this.backPara = 'detial'
			const typeid = this.selectType;
			sessionStorage.setItem('hasList', '1')
			this.$router.push({ name: 'dataDetail', query: { dataDetail: 'dataDetail',typeid: typeid, id: id} })
		},
		sortClick(index){
			console.log(index)
		},
		// 查询筛选条件的数据
		selectData(data){
			console.log(data)
			this.isCenter = false;
			this.isSearch = true;
			this.backPara = 'select'
			this.selectName = data.name;
			this.selectType = data.id;
			this.page = 1;
			this.getSearch(data.id);
			sessionStorage.removeItem("dataid");
		},
		onBack(para) {
			//  判断点击返回按钮的时机
			if(para == 'center'){
				envnetBus.$emit('loginDataBase',true)
			}else if(para == 'select'){
				this.filterSortList = []
				this.page = 1
				this.isCenter = true;
				this.isSearch = false;
				this.backPara = 'center'
			}
		},
		onSearchPress(e) {
			// this.searchString = e.target.value;
			if (this.searchString == '') {
				this.filterSortList = this.sortList
			} else {
				apiUtil.get(apiConst.dataSearch, {id: this.selectType, page: 1, keywords: this.searchString}).then(res => {
					this.filterSortList = res.data
				})
			}
		},
		getChange() {
			console.log(this.searchString)
		},
		onSearchClearClick() {
			this.searchString = '';
			this.$refs.searchIpt.blur()
			this.$emit('clear');
		},
		dataSelect(){
			this.popShow = true;
		}
	}
};
</script>

<style lang="stylus" scoped>
.datacenter{
	height: 100%;
	overflow-y: auto;
	padding-bottom: 60px;
    .centerhead{
			position: sticky;
			left: 0;
			right: 0;
			top: 0;
			display: flex;
			align-items: center;
			height: 100px;
			padding: 12px 30px;
			background-color: #fff;
			z-index: 99;
			transition: all .2s linear;
			border-bottom: solid 1px #d4c4c4;
			overflow: hidden
			.centerleft {
					flex: 0 0 82px;
					.logo {
						width: 54px;
						height: 54px;
					}
					.back-img {
						width: 24px;
						height: 40px;
					}
				}
        .centermiddle{
            flex: 1;
            .search-input-wrap {
				width: 100%;
				height: 64px;
				position: relative;
                .search-input-wrap--inner {
					width: 70%;
					height: 100%;
				}
                .cancel-btn {
					position: absolute;
					display: inline-block;
					top: 4px;
					right :200px;
					color: #666;
					font-size: 48px;
					font-weight: bold;
				}
				.databtn{
					background-color:#5b9bd5;
					position: absolute;
					display: inline-block;
					top: 6px;
					right :10px;
					color: #fff;
					font-size: 25px;
					padding: 15px 30px;
					border-radius:20px;
				}
				.search-input {
					width: 100%;
					height: 100%;
					line-height: 64px;
					padding-left: 60px;
					font-size: 28px;
					color: #999;
					background: url('../../assets/images/search.png') 20px center no-repeat #F4F4F4;
					background-size: 28px;
					border-radius: 50px;
                    background-color: #fff;
                    border: solid 1px #bfbfbf;
					&::-webkit-search-cancel-button {
						display: none;
					}
				}
            }
        }
    }
	.datatitle{
		margin-top: 40px;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		.titleicon{
			width:40px;
		}
		.titlename{
			padding-left: 20px;
			font-size: 30px;
			font-weight: 600;
		}
	}
	.datacontent{
		margin-top:40px;
		.dataitem{
			height :100px;
			display: flex;
			justify-content: space-evenly;
			align-items: center;
			background-image: linear-gradient(to right, #f5f8fc , #e2ecf8);
			margin: 50px;
			border-radius: 60px; 
			border: solid 1px #9dc3e6
			.itemiconlayout{
				width:20%;
				.itemicon{
					width:80px;
				}
			}
			.itemname{
				width: 60%;
				font-weight: 600;
				font-size: 25px; 
			}
		}
	}
	.no-content {
		height: 300px;
		line-height: 300px;
		color: #999;
		text-align: center;
		margin-bottom: 30px;
		font-size: 25px;
	}
	.popwindow{
		border-radius: 20px 20px 0 0;
		.poptitle{
			height: 60px;
			background-color: #5b9bd5;
			border-radius: 20px 20px 0 0;
			color: #fff;
			text-align: center;
			line-height: 60px;
		}
		.greendev{
			padding: 40px;
			border-bottom: solid 1px #bfbfbf;
			.devselect{
				padding: 10px 0;
				width: 100%;
				border-radius: 40px;
			}
			
		}
		.datayear{
			font-size: 30px;
			font-weight: 600;
			padding: 20px 40px ;
		}
		.databottom{
			border-bottom: solid 0px;
		}
		.secletdata{
			padding: 0 40px;
		}
	}
	.sorts{
		margin: 30px 0;
		height: 60px;
		background-color: #f2f2f2;
		display: flex;
		align-items: center;
		justify-content: left;
		padding-left: 30px;
		.sortitem{
			font-size: 25px;
			display: flex;
    		align-items: center;
			.sortimg{
				width: 25px;
			}
		}
		
	}
	.sortlist{
		height: 240px;
		display: flex;
    	align-items: flex-start;
		border-bottom: solid 1px #bfbfbf;
		margin: 30px;
		padding-bottom: 30px;
		.listleft{
			width: 200px;
			height: 200px;
			text-align: center;
			.listimg{
				height: 100px;
				display: flex;
				justify-content: center;
				align-items: center;
				.listdetial{
					background-color: #5b9bd5;
					color: #fff;
					font-size: 20px;
					display: inline-block;
					width: 120px;
					height: 50px;
					line-height: 50px;
					text-align:center;
					border-radius: 40px;
					margin-top 20px;
				}
			}
			img{
				width: 150px;
			}
		}
		.listright{
			font-size: 25px;
			padding-left: 20px;
			.listtitle{
				font-weight: bold;
				height: 40px;
				line-height: 40px;
			}
			.listcontent{
				height: 40px;
				line-height: 40px;
			}
		}
		
	}
}
</style>
<style>
.van-picker__cancel, .van-picker__confirm, .van-picker-column__item{
	font-size: 30px;
}
</style>
